import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

/**
 * دالة مساعدة لعمل الكونفرميشن بشكل احترافي في كامل المشروع
 * @param {string} title العنوان (مثال: هل أنت متأكد؟)
 * @param {string} text النص التوضيحي (اختياري)
 * @param {string} confirmButtonText نص زر التأكيد (الافتراضي: نعم)
 * @param {string} cancelButtonText نص زر الإلغاء (الافتراضي: إلغاء)
 * @param {string} icon الأيقونة (warning, success, error, info, question)
 * @returns {Promise<boolean>} يرجع true إذا وافق المستخدم، و false إذا ألغى
 */
export const showConfirm = async ({
  title = "هل أنت متأكد؟",
  text = "لا يمكن التراجع عن هذا الإجراء!",
  confirmButtonText = "نعم، متأكد",
  cancelButtonText = "إلغاء",
  icon = "warning",
  confirmButtonColor = "#dc3545", // أحمر كافتراضي للحذف والأرشفة
  cancelButtonColor = "#6c757d",
} = {}) => {
  const result = await MySwal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor,
    cancelButtonColor,
    confirmButtonText,
    cancelButtonText,
    reverseButtons: true, // مهم جداً للغة العربية لعكس أزرار التأكيد والإلغاء
    customClass: {
      popup: 'swal2-arabic-popup', // يمكن تخصيصها في index.css
    }
  });

  return result.isConfirmed;
};

export const showSuccess = (title = "تم بنجاح", text = "") => {
  return MySwal.fire({
    title,
    text,
    icon: "success",
    confirmButtonColor: "#28a745",
    confirmButtonText: "حسناً",
  });
};

export const showError = (title = "حدث خطأ!", text = "") => {
  return MySwal.fire({
    title,
    text,
    icon: "error",
    confirmButtonColor: "#dc3545",
    confirmButtonText: "حسناً",
  });
};
